import Input from "../../../form/input"

const TitleField = () => (
  <div className="pt-6">
    <Input label="Title" name="title" />
  </div>
)

export default TitleField
